document.brklz = document.brklz || {};
document.brklz.remove_duplicates = document.brklz.remove_duplicates || {};

$( document ).ready(function() {
  document.brklz.remove_duplicates.removeDuplicates();
});

document.brklz.remove_duplicates.removeDuplicates = function () {
  var i,
    product_element_id,
    product_ids = '',
    products = document.querySelectorAll('.product-wrap');
  for (i = 0; i < products.length; i++) {
    product_element_id = products[i].querySelector('.title').getAttribute("product-id");
    if (product_ids.indexOf('_' + product_element_id + '_') >= 0) {
      products[i].parentElement.style.display = 'none';
    } else {
      product_ids += '_' + product_element_id + '_';
    }
    if (i === products.length - 1) {
      document.brklz.remove_duplicates.displayProducts();
    }
  }
};

document.brklz.remove_duplicates.displayProducts = function () {
  document.querySelector('.product-list').style.opacity = '1';
};
